import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { BonusAvailable } from '@user/const';
import { map, Observable, tap } from 'rxjs';
import { CustomUserActions } from '../store/actions';
import { CustomUserSelectors } from '../store/selectors';
import { StateWithCustomUser } from '../store/user-state';

@Injectable({
  providedIn: 'root',
})
export class LoyaltyProgramFacade {
  constructor(private store: Store<StateWithCustomUser>) {}

  getBonusBalance(): Observable<BonusAvailable> {
    return this.store.pipe(select(CustomUserSelectors.getBonusBalanceValue));
  }

  loadBonusBalance(): void {
    this.store.dispatch(new CustomUserActions.LoadBonusBalance());
  }

  loadIfNeedBonusBalance(): Observable<StateUtils.LoaderState<BonusAvailable>> {
    return this.store.pipe(
      select(CustomUserSelectors.getBonusBalanceState),
      tap((state) => {
        if (!state.loading && !state.error && !state.success) {
          this.store.dispatch(new CustomUserActions.LoadBonusBalance());
        }
      }),
    );
  }

  joinLoyaltyProgram(): void {
    this.store.dispatch(new CustomUserActions.JoinLoyaltyProgram());
  }

  getJoinLoyaltyProgramLoading(): Observable<boolean> {
    return this.store.pipe(select(CustomUserSelectors.getLoyaltyProgramLoading));
  }

  getJoinLoyaltyProgramSuccess(): Observable<boolean> {
    return this.store.pipe(select(CustomUserSelectors.getLoyaltyProgramSuccess));
  }

  getIsUserMemberOfLoyaltyProgram(): Observable<boolean> {
    return this.store.pipe(
      select(CustomUserSelectors.getBonusBalanceValue),
      map((bonusAvailable: BonusAvailable | undefined) => !!bonusAvailable?.segmentName),
    );
  }

  getIsUserMemberOfLoyaltyProgramLoading(): Observable<boolean> {
    return this.store.pipe(select(CustomUserSelectors.getBonusBalanceLoading));
  }
}
